import { generateHookExports } from "api/generateExports";
import { createCRUDService } from "api/queryService";
import axios from "../axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API_CONFIG } from "services/apiConfig";
import { showToast } from "services/utils";
import { formatPayloadIfNeeded } from "api/utils";

let baseData = API_CONFIG.CONTROL_OF_NON_CONFIRMING;
const BASE_URL = baseData?.path;
const QUERY_KEY = baseData?.queryKey;

const nonConformingProductService = createCRUDService({
  baseUrl: BASE_URL,
  queryKey: QUERY_KEY,
  custom: {
    getChartData: (params = {}, options = {}) => {
      return useQuery({
        queryKey: [QUERY_KEY, "getChartData", params],
        queryFn: () => {
          return axios
            .get(`${BASE_URL}/get-chart-data`, { params })
            .then((res) => res.data);
        },
        enabled: options.enabled ?? true,
        retry: options.retry ?? 1,
      });
    },
    updateRegister: () => {
      return useMutation({
        mutationFn: (payload) => {
          const data = formatPayloadIfNeeded(
            payload,
            payload?.isCustomImage ?? false
          );
          return axios
            .put(`${BASE_URL}/update-register`, data, {
              headers:
                data instanceof FormData
                  ? { "Content-Type": "multipart/form-data" }
                  : {},
            })
            .then((res) => res.data);
        },
        onSuccess: (data) => {
          showToast(data);
        },
        onError: (error) => {
          showToast(error?.data);
        },
      });
    },
  },
});

export const {
  nonConformingProductGetById,
  nonConformingProductDownload,
  nonConformingProductUpdate,
  nonConformingProductCreate,
  nonConformingProductList,
  nonConformingProductUpdateSpecific,
  nonConformingProductGetChartData,
  nonConformingProductUpdateRegister,
} = generateHookExports(nonConformingProductService, "nonConformingProduct");
